import http from '@/http'

export const actions = {
  getVerify (context, token) {

    return http({
      url: `/api/user/verify/${token}`,
      method: "GET"
    })
  },

  postRequestInvite (context, data) {

    return http.post('/api/user/request/invite', data)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject(response)
        }
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },

  postPasswordRecover (context, data) {

    return http.post('/api/user/password-recover/', data)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject(response)
        }
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },

  postPasswordReset (context, { user, token }) {

    return http.post(`/api/user/password-reset/${user}/${token}/`)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject()
        }
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },

  postSetPassword (context, { user, data }) {

    return http.post(`/api/user/password-reset/${user}/set-password/`, data)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject()
        }
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }
}

export default {
  namespaced : true,
  actions
}
